export const LAYERS = {
  basicModalOverlay: 100,
  basicModalContent: 110,
  profilePopup: 120,
  dialogOverlay: 130,
  dialogContent: 140,
  floatingUi: 150,
  toast: 200,
} as const;

export const LAYER_CSS_VARS = {
  basicModalOverlay: "var(--z-basic-modal-overlay)",
  basicModalContent: "var(--z-basic-modal-content)",
  profilePopup: "var(--z-profile-popup)",
  dialogOverlay: "var(--z-dialog-overlay)",
  dialogContent: "var(--z-dialog-content)",
  floatingUi: "var(--z-floating-ui)",
  toast: "var(--z-toast)",
} as const;
